import { DictUtil } from 'jczh-ui'

// 企业收费类型字典
export const feeTypeDict = new DictUtil({
  SIGN_UP_PAY: {
    value: 'SIGN_UP_PAY',
    label: '平台使用费'
  },
  BOOK_FEE_PAY: {
    value: 'BOOK_FEE_PAY',
    label: '标书费'
  },
  SERVICE_FEE_PAY: {
    label: '服务费',
    value: 'SERVICE_FEE_PAY'
  },

  AGENT_SERVICE_FEE_PAY: {
    label: '技术服务费',
    value: 'AGENT_SERVICE_FEE_PAY'
  },

  // CHARGE: {
  //   value: 'SERVICE_CHARGE_PAY',
  //   label: '手续费'
  // },

  CA_PAY: {
    label: '平台CA',
    value: 'CA_PAY'
  },
  ESIGN_PAY: {
    value: 'ESIGN_PAY',
    label: '电子签章'
  },
  VAS: {
    value: 'VAS',
    label: '平台增值服务'
  }
})

// 个人收费类型
export const personalFeeTypeDict = new DictUtil({
  VAS_READ_PAY: {
    value: 'VAS_READ_PAY',
    label: '增值服务(标讯)'
  },
  VAS_BOOK_LOOK_PAY: {
    value: 'VAS_BOOK_LOOK_PAY',
    label: '增值服务(标书预览)'
  },
  VAS_ONE_LEVEL_PAY: {
    value: 'VAS_ONE_LEVEL_PAY',
    label: '增值服务(标前狗普通会员)'
  },
  VAS_SECOND_LEVEL_PAY: {
    value: 'VAS_SECOND_LEVEL_PAY',
    label: '增值服务(标前狗高级会员)'
  },
  VAS_THREE_LEVEL_PAY: {
    value: 'VAS_THREE_LEVEL_PAY',
    label: '增值服务(标前狗钻石会员)'
  }
})

// 开票状态
export const invoiceApplyStatusDict = new DictUtil({
  NOT_APPLY: {
    label: '未申请',
    value: 0,
    type: 'info'
  },
  APPLIED: {
    label: '已申请',
    value: 1,
    type: 'primary'
  },
  INVOICED: {
    label: '已开票',
    value: 2,
    type: 'success'
  },
  REJECTED: {
    label: '已拒绝',
    value: 3,
    type: 'danger'
  },
  // 线下开票
  OFFLINE_INVOICE: {
    value: 4,
    label: '线下开票'
  }
})

// 发票开具类型
export const invoiceApplyTypeDict = new DictUtil({
  SINGLE_APPLY: {
    label: '单张开票',
    value: 1
  },
  COMBINE_APPLY: {
    label: '合并开票',
    value: 2
  }
})

// 项目类型
export const financialProjectTypeDict = new DictUtil({
  ZB: {
    label: '招标',
    value: 1
  },
  XB: {
    label: '询比',
    value: 2
  },
  JZ: {
    label: '竞价',
    value: 3
  }
})

// 支付类型
export const payTypeDict = new DictUtil({
  PING_AN_ALI_QR: {
    label: '支付宝',
    value: 1
  },
  PING_AN_WX_QR: {
    label: '微信',
    value: 2
  },
  PING_AN_DEPOSIT: {
    label: '线下汇款',
    value: 3
  },
  PING_AN_WX_MINI: {
    value: 6,
    label: '微信小程序支付'
  }
})

// 发票抬头类型
export const invoiceTitleTypeDict = new DictUtil({
  COMPANY: { label: '企业单位', value: 1 },
  PERSONAL: { label: '个人', value: 2 }
})

// 开票类型
export const invoiceTypeDict = new DictUtil({
  /**
   * 非精彩纵横收费
   */
  GENERAL_ELECTRONIC_INVOICE: {
    label: '普票',
    value: 'invoice_normal',
    alias: '电子普通发票'
  },
  SPECIAL_PAPER_INVOICE: {
    label: '专票',
    value: 'invoice_special',
    alias: '专用发票'
  },
  /**
   * 精彩纵横收费
   */
  INVOICE_NORMAL_YONYOU: {
    label: '数电普票',
    value: 'invoice_normal_yonyou'
  },
  INVOICE_SPECIAL_YONYOU: {
    label: '数电专票',
    value: 'invoice_special_yonyou'
  }
})

// 支付类型
export const orderTypeDict = new DictUtil({
  COMPANY: {
    value: 0,
    label: '企业'
  },
  PERSONAL: {
    value: 1,
    label: '个人'
  }
})

// 支付渠道
export const payChannelDict = new DictUtil({
  PC: {
    value: 0,
    label: 'PC'
  },
  MINI_PROGRAM: {
    value: 1,
    label: '小程序'
  }
})

// 异常保证金状态
export const abnormalGuaranteeFeeStatusDict = new DictUtil({
  PENDING: { label: '异常缴纳-待申请', value: -1 },
  RETURNING: { label: '异常缴纳-退款中', value: 1 },
  RETURNED: { label: '异常缴纳-已退款', value: 2 },
  FAILED: { label: '异常缴纳-退款失败', value: 0 },
  TIMEOUT: { label: '异常缴纳-退款超时', value: -2 }
})

// 保证金业务类型
export const guaranteeFeeBizTypeDict = new DictUtil({
  ZB: { label: '招标采购', value: 'ZB' },
  XB: { label: '询比采购', value: 'XB' },
  JZ: { label: '竞价采购', value: 'JZ' },
  // VAS: { label: '增值服务', value: 'VAS' },
  TP: { label: '谈判采购', value: 'TP' },
  HTP: { label: '谈判采购', value: 'HTP' }
})

// 是否企业信息
export const isCompanyDict = new DictUtil({
  COMPANY: {
    value: 0,
    label: '企业'
  },
  PERSONAL: {
    value: 1,
    label: '个人'
  }
})

// 是否本公司
export const isWhetherOurCompanyDict = new DictUtil({
  YES: { value: 1, label: '是' },
  NO: { value: 0, label: '否' }
})
